import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { LegalDocumentModal } from './LegalDocumentModal.component'

const withUnmountHoc = withUnmountTransition(LegalDocumentModal)
export { withUnmountHoc as LegalDocumentModal }
